import { render, staticRenderFns } from "./ReportFavorite.vue?vue&type=template&id=977eea00"
import script from "./ReportFavorite.vue?vue&type=script&lang=js"
export * from "./ReportFavorite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports